import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({ selector: '[appLongPress]' })
export class LongPressDirective {
  @Input() public duration = 500;
  @Output() public longPress: EventEmitter<any> = new EventEmitter();
  @Output() public longPressing: EventEmitter<any> = new EventEmitter();
  @Output() public longPressEnd: EventEmitter<any> = new EventEmitter();

  private _isPressing: boolean;
  private _isLongPressing: boolean;
  private timeout: number;
  private mouseX = 0;
  private mouseY = 0;

  @HostBinding('class.press')
  public get isPressing() {
    return this._isPressing;
  }

  public set isPressing(v) {
    this._isPressing = v;
  }

  @HostBinding('class.longpress')
  public get isLongPressing() {
    return this._isLongPressing;
  }

  public set isLongPressing(v) {
    this._isLongPressing = v;
  }

  @HostListener('mousedown', ['$event'])
  public onMouseDown(event) {
    // don't do right/middle clicks
    if (event.which !== 1) {
      return;
    }

    this.mouseX = event.clientX;
    this.mouseY = event.clientY;

    this.isPressing = true;
    this.isLongPressing = false;

    this.timeout = window.setTimeout(() => {
      this._isLongPressing = true;
      this.longPress.emit(event);
      this.loop(event);
    }, this.duration);

    this.loop(event);
  }

  @HostListener('mousemove', ['$event'])
  public onMouseMove(event) {
    if (this.isPressing && !this.isLongPressing) {
      const xThres = event.clientX - this.mouseX > 10;
      const yThres = event.clientY - this.mouseY > 10;
      if (xThres || yThres) {
        this.endPress();
      }
    }
  }

  public loop(event) {
    if (this.isLongPressing) {
      this.timeout = window.setTimeout(() => {
        this.longPressing.emit(event);
        this.loop(event);
      }, 50);
    }
  }

  public endPress() {
    clearTimeout(this.timeout);
    this.isLongPressing = false;
    this.isPressing = false;
    this.longPressEnd.emit(true);
  }

  @HostListener('mouseup')
  public onMouseUp() {
    this.endPress();
  }

  @HostListener('mouseleave')
  public onMouseLeave() {
    if (this.isPressing) {
      this.endPress();
    }
  }
}
